module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-descriptor.js
// module id = 64
// module chunks = 35783957827783 114276838955818 162898551421021